import { detect, track, isEnabled } from "@otto-ec/global-mpathy";
import { o_global } from "../namespaces";

/*                                          */
/*                                   */
detect(window.navigator.userAgent);

const mpathy = { track, isEnabled };

export type Mpathy = typeof mpathy;

/*                                                */
o_global.mpathy ||= mpathy;
